var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.articlesLoading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [_c("loading-overlay")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.articlesLoading
          ? _c("div", { staticClass: "row py-5" }, [
              _vm.checkArticles
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 background-articles",
                      class: _vm.noMatchesBackground
                    },
                    [
                      _vm.inputFilter.length === 0 &&
                      _vm.currentPage === _vm.paginationFirstPage
                        ? _c("KnowledgeBlockArticle", {
                            attrs: {
                              title: "Most popular",
                              "show-reference-text":
                                _vm.currentPage === 1 && _vm.checkHRPlatform,
                              "custom-articles": _vm.slicedArticles
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkArticlesDisplaying
                        ? _c("KnowledgeBlockArticle", {
                            attrs: {
                              title: _vm.displayedArticlesTitle,
                              "show-reference-text":
                                _vm.currentPage > 1 && _vm.checkHRPlatform,
                              "custom-articles": _vm.displayedArticles
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.inputFilter.length > 0 &&
                      _vm.filteredArticles.length === 0
                        ? _c(
                            "div",
                            { staticClass: "no-matches-container row pl-4" },
                            [_c("h4", [_vm._v(_vm._s(_vm.noMatchesFound))])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPagination,
                              expression: "showPagination"
                            }
                          ],
                          staticClass:
                            "row ml-0 flex-md-row flex-column justify-content-center justify-content-md-between align-items-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "pagination-items-count mb-4 mb-md-0"
                            },
                            [_vm._v(_vm._s(_vm.countItems))]
                          ),
                          _vm._v(" "),
                          _c("pagination", {
                            attrs: {
                              "per-page": _vm.perPage,
                              "displayed-list": _vm.checkDisplayedList
                            },
                            on: { paginate: _vm.paginate }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.checkEmptyArticles
        ? _c(
            "div",
            {
              staticClass: "mt-5 row justify-content-center align-items-center"
            },
            [_c("h5", [_vm._v(_vm._s(_vm.noArticlesFound))])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c93d594", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c93d594","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeServices.vue
// module id = null
// module chunks = 